import axiosInstance from "@/lib/axios";

export const withdrawalService = {
  // Liste des demandes de retrait (admin), filtrable par statut.
  getWithdrawals: async ({ page = 1, status = null }) => {
    let url = `/api/v1/admin/withdrawals?page=${page}`;
    if (status) url += `&status=${status}`;

    const response = await axiosInstance.get(url);
    return response.data;
  },

  // Valide une demande : preuve de paiement obligatoire.
  approve: async (id, proofFile) => {
    const formData = new FormData();
    formData.append("proof", proofFile);

    const response = await axiosInstance.post(
      `/api/v1/admin/withdrawals/${id}/approve`,
      formData
    );
    return response.data;
  },

  // Refuse une demande avec motif obligatoire.
  reject: async (id, reason) => {
    const response = await axiosInstance.post(
      `/api/v1/admin/withdrawals/${id}/reject`,
      { reason }
    );
    return response.data;
  },
};

export default withdrawalService;
